import { Control, Controller } from 'react-hook-form';
import { CatalogProductsFormData } from '../../create-product-dialog-types';
import { isNotEmptyArray, isNotNullOrUndefined } from '@vy/utils';
import { createPaddleIntegrationEntity } from '../../../../../../../utils/integration-entity-creators';
import { Autocomplete, TextField } from '@mui/material';
import { useFormattedPaddleProducts } from '../../../../../../../hooks/use-formatted-paddle-products';

type PaddleProductsDropdownProps = {
  control: Control<CatalogProductsFormData>;
};

export const PaddleProductsDropdownForCatalog: React.FC<PaddleProductsDropdownProps> = ({
  control,
}) => {
  const { products: formattedProducts } = useFormattedPaddleProducts();

  return (
    <Controller
      control={control}
      name="paddleProduct"
      render={({ field }) => {
        const currentValue = isNotEmptyArray(field.value) ? field.value?.at(0) : null;

        const canFindProduct = isNotNullOrUndefined(currentValue) && isNotEmptyArray(formattedProducts);

        const matchingProduct = canFindProduct
          ? formattedProducts.find((product) => product.id === currentValue.integrationExternalId)
          : null;

        return (
          <Autocomplete
            options={formattedProducts}
            multiple={false}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={matchingProduct}
            onChange={(_, value) => {
              const newEntity = createPaddleIntegrationEntity(value);
              field.onChange(newEntity ? [newEntity] : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Paddle Products"
                placeholder="Select Paddle product"
                size="small"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            )}
          />
        );
      }}
    />
  );
};
